import React from 'react';
import ExpandCollapse from './ExpandCollapse';

/**
 * 'Accordion' is a shorthand for an ExpandCollapse where only one item may be open at a time
 */
import { jsx as _jsx } from "react/jsx-runtime";
const Accordion = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/_jsx(ExpandCollapse, {
  ref: ref,
  ...props,
  maxOpen: 1
}));
Accordion.displayName = 'Accordion';
Accordion.propTypes = ExpandCollapse.propTypes;
export default Accordion;